var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.25,
    width: 17.5,
    height: 17.5,
    rx: 8.75,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3866 6.05759C8.3866 6.64169 7.88032 7.11519 7.2558 7.11519C6.63128 7.11519 6.125 6.64169 6.125 6.05759C6.125 5.4735 6.63128 5 7.2558 5C7.88032 5 8.3866 5.4735 8.3866 6.05759Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27964 7.89256H8.21263V13.75H6.27964V7.89256Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3247 7.89256H9.39175V13.75H11.3247C11.3247 13.75 11.3247 11.906 11.3247 10.753C11.3247 10.061 11.561 9.36596 12.5039 9.36596C13.5694 9.36596 13.563 10.2716 13.558 10.9732C13.5515 11.8903 13.567 12.8262 13.567 13.75H15.5V10.6586C15.4836 8.68461 14.9693 7.77505 13.2771 7.77505C12.2721 7.77505 11.6492 8.23129 11.3247 8.64406V7.89256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/linkedin-blue.79677e79cc568ca4bb41a91a9a7e578d.svg";
export { ForwardRef as ReactComponent };